import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Typography,
  Card,
  CardContent,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Spinner from "../Spinner/Spinner";
import ComputerIcon from "@mui/icons-material/Computer";

const AppSelectorPage = ({permissions }) => {
  const navigate = useNavigate();
  const { VCOI, DCOI } = permissions || {};
  const [checkingPermissions, setCheckingPermissions] = useState(true);

  useEffect(() => {
    // Auto-redirect if user has access to only one app
    if (VCOI && !DCOI) {
      navigate("/app-vcoi");
    } else if (!VCOI && DCOI) {
      navigate("/app-dcoi");
    } else {
      setCheckingPermissions(false);
    }
  }, [VCOI, DCOI, navigate]);
  if (!VCOI && !DCOI) {
    return (
      <Box
        sx={{
          height: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography variant="h6" color="error">
          You do not have access to any application.
        </Typography>
      </Box>
    );
  }

  // App card data
  const appCards = [
    {
      key: "dcoi",
      title: "DCOI APP",
      description:
        "Enter the Digital Conflict Of Interest Application and enhance your data management strategies.",
      path: "/app-dcoi",
      visible: DCOI,
    },
    {
      key: "vcoi",
      title: "VCOI APP",
      description:
        "Enter the Vendor Conflict Of Interest Application and enhance your data management strategies.",
      path: "/app-vcoi",
      visible: VCOI,
    },
  ];

  return (
    <Box
      sx={{
        minHeight: "65vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f5f5",
        p: 3,
      }}
    >
      {/* Content Wrapper — aligns header and grid together */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
        }}
      >
        {/* Header */}
        <Box sx={{ mb: 5 }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: "bold", mb: 1, textAlign: "left" }}
          >
            Select Application
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              textAlign: "left",
            }}
          >
            Choose an application to explore innovative solutions and optimize
            your processes.
          </Typography>
        </Box>

        {/* App Cards */}
        <Grid container spacing={4}>
          {appCards
            .filter((app) => app.visible)
            .map((app) => (
              <Grid item xs={12} sm={6} md={6} key={app.key}>
                <Card
                  sx={{
                    p: 2,
                    borderRadius: 3,
                    boxShadow: 2,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <CardContent>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <ComputerIcon
                        sx={{ fontSize: 32, color: "text.secondary", mb: 1 }}
                      />
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: "bold", mb: 1 }}
                      >
                        {app.title}
                      </Typography>
                    </Box>

                    <Typography
                      variant="body2"
                      sx={{ color: "text.secondary" }}
                    >
                      {app.description}
                    </Typography>
                  </CardContent>

                  <Box>
                    <Divider sx={{ my: 2 }} />
                    <Button
                      fullWidth
                      variant="contained"
                      sx={{
                        backgroundColor: "black",
                        color: "white",
                        borderRadius: 5,
                        textTransform: "none",
                        fontWeight: "bold",
                        "&:hover": { backgroundColor: "#333" },
                      }}
                      onClick={() => navigate(app.path)}
                    >
                      Select
                    </Button>
                  </Box>
                </Card>
              </Grid>
            ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default AppSelectorPage;